import classNames from "classnames";
import { useLocation } from "react-router-dom";

import { Header } from "../../components/header/header";
import { PageSupport } from "../../components/utilities/page-support";
import { SliderCarousel } from "../../components/utilities/gen-slider";
import { server } from "../../services/config/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faUserTie } from "@fortawesome/free-solid-svg-icons";
import DOMPurify from "dompurify";
import { Footer } from "../../components/footer/footer";
import { SharePannel } from "../../components/forms/share";
import YouTube from "react-youtube";


export const BlogDetails = () => {
    const { blogData, images } = useLocation().state;

    const formatUrl = (uri) => `${server}/${uri}`;

    const formattedImages = images?.map((img) => formatUrl(img));

    const parseDate = (dt) => new Date(dt).toLocaleDateString('en-GB', {
        hour: '2-digit',
        day: '2-digit',
        year: 'numeric',
        month: 'short',
        minute: '2-digit'
    });

    const options = {
        height: '390',
        width: '640',
        playerVars: {
          autoplay: 1,
          controls: 1,
        },
      };


    return (
        <div className="f-pg">
            <PageSupport />
            <Header pageTitle={blogData?.title} />
            <div className="blog-detail">
                <div className={classNames("blog-data")}>
                    <div className="blog-det-tt">
                        {blogData?.title}
                    </div>
                    <div className={classNames("meta-col", 'flx-r-w')}>
                        <div className="post-nm">
                            <FontAwesomeIcon icon={faUserTie} />
                            <div className="nm">{blogData?.admin_names}</div>
                        </div>
                        <div className="post-nm">
                            <FontAwesomeIcon icon={faCalendarAlt} />
                            <div className="nm">{parseDate(blogData?.created_at)}</div>
                        </div>
                        <SharePannel blog={blogData} />
                    </div>

                </div>
                <SliderCarousel data={formattedImages} />
                <div
                    className="blog-txt"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blogData?.content) }}
                />
                {blogData?.videourl &&
                    <article style={{margin:"auto"}}>
                        <YouTube 
                            videoId={blogData?.videourl.split("v=")[1].substring(0, 11)}
                            options={options} 
                        />
                    </article>
                }
                
            </div>
            <Footer />
        </div>
    );
}